// SPDX-License-Identifier: MIT
import type { SceneModule } from '../scene.ts';
import cardStorm from './card-storm.ts';
import colorFlip from './color-flip.ts';
import editorialLines from './editorial-lines.ts';
import emberLockup from './ember-lockup.ts';
import kineticHeadline from './kinetic-headline.ts';
import logoAssemble from './logo-assemble.ts';
import logoIgnite from './logo-ignite.ts';
import metricSpans from './metric-spans.ts';
import nodeField from './node-field.ts';
import posterLockup from './poster-lockup.ts';
import signalGrid from './signal-grid.ts';
import slotNumbers from './slot-numbers.ts';
import statCounter from './stat-counter.ts';
import uiCta from './ui-cta.ts';
import uiDashboard from './ui-dashboard.ts';
import uiMorph from './ui-morph.ts';
import uiSteps from './ui-steps.ts';
/**
 * The scene kit. Library scenes (v2) were harvested from reviewed custom scenes and adapt to the
 * brand (dark or light ground, any logo or none, CJK copy) and to their length in beats. The M0
 * benchmark scenes stay for the render benchmark.
 */
export const LIBRARY_SCENES = [
    logoIgnite,
    editorialLines,
    metricSpans,
    nodeField,
    colorFlip,
    emberLockup,
    posterLockup,
    uiMorph,
    uiCta,
    uiDashboard,
    uiSteps,
];
export const BENCHMARK_SCENES = [
    signalGrid,
    cardStorm,
    kineticHeadline,
    statCounter,
    slotNumbers,
    logoAssemble,
];
export const SCENE_KIT: Record<string, SceneModule<never>> = Object.fromEntries([...LIBRARY_SCENES, ...BENCHMARK_SCENES].map((s) => [s.id, s as unknown as SceneModule<never>]));
